import { render, staticRenderFns } from "./the-background-item.vue?vue&type=template&id=ad4e6726&scoped=true&"
import script from "./the-background-item.vue?vue&type=script&lang=js&"
export * from "./the-background-item.vue?vue&type=script&lang=js&"
import style0 from "./the-background-item.vue?vue&type=style&index=0&id=ad4e6726&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4e6726",
  null
  
)

export default component.exports